import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import type { UnifiedBreadcrumbProps } from './Layout.types';

export type { UnifiedBreadcrumbProps } from './Layout.types';


export function UnifiedBreadcrumb({ items, homeUrl = '/entry' }: UnifiedBreadcrumbProps) {
  if (items.length === 0) return null;

  return (
    <div style={{
      height: '44px',
      padding: '0 16px',
      borderBottom: '1px solid hsl(220 13% 91%)',
      backgroundColor: 'hsl(0 0% 100%)',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
    }}>
      <a href={homeUrl} style={{ color: 'hsl(220 9% 46%)', textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
        <Home style={{ width: '16px', height: '16px' }} />
      </a>
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        const linkStyle: React.CSSProperties = {
          color: isLast ? 'hsl(220 9% 20%)' : 'hsl(220 9% 46%)',
          textDecoration: 'none',
          fontWeight: isLast ? 500 : 400,
          fontFamily: 'inherit',
          fontSize: 'inherit',
          lineHeight: 'inherit',
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: item.onClick || item.href ? 'pointer' : 'default',
        };
        return (
          <React.Fragment key={`${item.label}-${idx}`}>
            <ChevronRight style={{ width: '14px', height: '14px', color: 'hsl(220 9% 70%)', flexShrink: 0 }} />
            {item.onClick ? (
              <button type="button" onClick={item.onClick} style={linkStyle}>
                {item.label}
              </button>
            ) : item.href && !isLast ? (
              <a href={item.href} style={linkStyle}>{item.label}</a>
            ) : (
              <span style={linkStyle}>{item.label}</span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
